module.exports = __webpack_public_path__ + "static/media/glorieta.aa53f63d.jpg";